import { useQuery } from '@tanstack/react-query'
import { OpalApiResponseDocument, OpalApiRequestParams } from '../../../schema'
import { blocks } from '../../../v3/blocks'
import { globalQueryKeys } from '../../queryKeys'

type BlockQueryParams = OpalApiRequestParams<'ReadBlockV3'>['query']
type ResponseDocument = OpalApiResponseDocument<'ReadBlockV3', 200>
type UseReadBlockV3Options<T = ResponseDocument> = {
  workspaceId: string
  blockId?: string
  select?: (data: ResponseDocument) => T
  query?: BlockQueryParams
  enabled?: boolean
}

export const useReadBlockV3 = <T = ResponseDocument>({
  workspaceId,
  blockId = '',
  select,
  query,
  enabled = Boolean(blockId),
}: UseReadBlockV3Options<T>) => {
  return useQuery({
    enabled,
    queryKey: globalQueryKeys.blockById(workspaceId, blockId, query),
    queryFn: () =>
      blocks.readSingle({
        path: { block_id: blockId },
        query: query ?? {},
      }),
    select,
  })
}
